import { renderSlot as _renderSlot, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-738af9ac")

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _mergeProps({
    class: ["ButtonRack", _ctx.classes]
  }, _ctx.$attrs), [
    _renderSlot(_ctx.$slots, "default")
  ], 16))
})